// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3b3Lo","name":"ConsentHeader_name__kfgIP","birthday":"ConsentHeader_birthday__3ToQ_","skeleton":"ConsentHeader_skeleton__1E7ET"};